<template>
  <div class="contest-entry-complete">
    <div class="image"><img src="@/assets/img/event/agent/complete.webp" /></div>
    <h2>{{ $t("agentEntryComplete.title") }}</h2>

    <div class="content">
      <p>{{ $t("agentEntryComplete.thankYou") }}</p>
      <p v-html="$t('agentEntryComplete.description2')"></p>
      <p>{{ $t("agentEntryComplete.description3") }}</p>
    </div>
  </div>
</template>

<script lang="ts">
import Vue, { PropType } from "vue";
import { NolaContest } from "@/lib/models/nolaContest";

export default Vue.extend<Data, Methods, Computed, Props>({
  props: {
    contest: Object as PropType<NolaContest>,
  },
});

interface Props {}

interface Data {}

interface Computed {}

interface Methods {}
</script>

<style lang="scss" scoped>
.contest-entry-complete {
  margin-top: 2rem;
  padding: 0 20%;
  color: var(--color-text-normal);

  h2 {
    text-align: center;
    font-size: 1.6em;
    margin-top: 2rem;
    color: var(--color-text-normal);
  }

  .content {
    margin-top: 2rem;
    color: var(--color-text-normal);
  }
}

.image {
  text-align: center;

  img {
    width: 35%;
  }
}

p {
  font-size: 1.1em;
  color: var(--color-text-normal);
}

</style>
